import { render, staticRenderFns } from "./UserTabLoginMethod.vue?vue&type=template&id=2c588d9f&"
import script from "./UserTabLoginMethod.vue?vue&type=script&lang=js&"
export * from "./UserTabLoginMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports